"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
const react_1 = __importDefault(require("react"));
const lottie_react_native_1 = __importDefault(require("lottie-react-native"));
const atoms_1 = require("../../atoms");
const S = __importStar(require("./Page.styles"));
const accessibility_1 = require("../../../../shared/accessibility");
exports.Page = ({ item }) => {
    const isString = (value) => typeof value === 'string';
    const isObject = (value) => typeof value === 'object';
    const renderHeader = () => {
        return isObject(item.source) ? (react_1.default.createElement(S.LottieContainer, null,
            react_1.default.createElement(lottie_react_native_1.default, { testID: "lottieView", resizeMode: "cover", source: item.source, autoPlay: true, loop: true, style: item.lottieViewStyle }))) : (react_1.default.createElement(S.Image, { testID: "image", resizeMode: "cover", source: item.source, style: item.imageStyle }));
    };
    const renderTitle = () => {
        return isString(item.title) ? (react_1.default.createElement(S.Title, Object.assign({ type: atoms_1.PTextType.LEAD, numberOfLines: 3 }, accessibility_1.accessibilityProps('onboarding-title')), item.title)) : (item.title);
    };
    const renderDescription = () => {
        return isString(item.description) ? (react_1.default.createElement(S.Description, Object.assign({ type: atoms_1.PTextType.VALUE, numberOfLines: 5 }, accessibility_1.accessibilityProps('onboarding-description')), item.description)) : (item.description);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        renderHeader(),
        renderTitle(),
        renderDescription()));
};
